import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { IBaseProps } from '@rbi-ctg/frontend';
import Currency from 'components/currency';
import { usePaymentContext } from 'state/payment';
import { IPaymentMethod } from 'state/payment/types';

import { PrepaidBalance, PrepaidMethodType } from './styled';

interface IPrepaidMethodBalance extends IBaseProps {
  method: IPaymentMethod;
}

const PrepaidMethodBalance = ({ method }: IPrepaidMethodBalance) => {
  const { getBalanceFromPaymentMethods } = usePaymentContext();
  const { formatMessage } = useIntl();

  return (
    <PrepaidMethodType>
      <div>{formatMessage(messages.payWithMyPrepaidCard)}</div>
      <span>-</span>
      <PrepaidBalance>
        <Currency amount={getBalanceFromPaymentMethods(method)} />
      </PrepaidBalance>
    </PrepaidMethodType>
  );
};

export default PrepaidMethodBalance;

const messages = defineMessages({
  payWithMyPrepaidCard: {
    id: 'payWithMyPrepaidCard',
    defaultMessage: 'Pay with my TimCard',
    description: 'No description',
  },
});
